@for (control of this.emailFormArray.controls; track control; let i = $index; let controlCount = $count) {
  <div class="zn-row">
    <div class="zn-col">
      <app-input-text
        [control]="control"
        [name]="'email'"
        [iconName]="'mail'"
        [hint]="'components.protocol.customer-card.email' | translate"
        [readonly]="disabled"
      />
    </div>

    <div class="zn-col-auto ps-0">
      @if ((controlCount > 1) && !disabled) {
        <zenith-button
          (click)="this.removeEmailAddressControl(i)"
          zn-appearance="secondary"
          zn-icon-name="delete"
          class="ml-2">
        </zenith-button>
      }
      @if (i === controlCount - 1 && !disabled) {
        <zenith-button
          (click)="this.addEmailAddressControl()"
          zn-appearance="secondary"
          zn-icon-name="add"
          class="ml-2">
        </zenith-button>
      }
    </div>
  </div>
}
